import suppliedTemplate from './template_auto_entrepreneur.json'

const autoEntrepreneurTemplate = JSON.parse(JSON.stringify(suppliedTemplate))

autoEntrepreneurTemplate.attributes = {
  ...(autoEntrepreneurTemplate.attributes || {}),
  'data-tax-regime': 'auto-entrepreneur',
  'data-vat-rate': '0'
}

export default autoEntrepreneurTemplate
